module.exports = __webpack_public_path__ + "static/img/sportGame.9dde66d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/hotGame/sportGame.png
// module id = SQe9
// module chunks = 3